import { render } from "./dl-loading.vue?vue&type=template&id=f98b725c"
import script from "./dl-loading.vue?vue&type=script&lang=js"
export * from "./dl-loading.vue?vue&type=script&lang=js"

import "./dl-loading.vue?vue&type=style&index=0&id=f98b725c&lang=scss"

import exportComponent from "/var/www/doctolib-hos-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__